/*eslint-disable*/
import  Vue from 'vue'
import router from './router/index'
import App from './App.vue'
import i18n from './i18n'
import store from './store'
import vuetify from './plugins/vuetify';
import CountryFlag from 'vue-country-flag'
import loader from "vue-ui-preloader";
import customsnackbar from './components/administrators/globalComponents/snackbar'
String.prototype.capitalize = function() {return this.charAt(0).toUpperCase() + this.slice(1);};
import { abilitiesPlugin } from '@casl/vue';
import ability from './plugins/ability';
import { Can } from '@casl/vue';
import VueClipboard from 'vue-clipboard2'
import VueFriendlyIframe from 'vue-friendly-iframe';
import UserMeansDatatable from './components/administrators/components/usermeanspaiement/datatable'
import '@fortawesome/fontawesome-free/css/all.css'
import '@fortawesome/fontawesome-free/js/all.js'
import VueIconPicker from "v-icon-picker";
import VueSocketIO from 'vue-socket.io';
import VuePhoneNumberInput from 'vue-phone-number-input'
import {env} from '../env'
Vue.use(new VueSocketIO({
    debug: false,
    connection: env.webservices,
    vuex: {
        store,
        actionPrefix: 'SOCKET_',
        mutationPrefix: 'SOCKET_'
    }
}));

Vue.use(VueIconPicker);
Vue.component('vue-phone-number-input', VuePhoneNumberInput);
import 'vue-phone-number-input/dist/vue-phone-number-input.css';
Vue.component('Can', Can);
Vue.use(abilitiesPlugin, ability);
Vue.component('country-flag', CountryFlag);
Vue.component('customsnackbar',customsnackbar)
Vue.component("user-means-datatable",UserMeansDatatable);

Vue.use(VueClipboard)
Vue.use(loader)

Vue.use(VueFriendlyIframe);
Vue.mixin( {
  data(){
    return {
      headerName:"Dashboard"//this.$t('dashboard')
    }
  },
  methods: {
    reloadPage(){
        location.reload();
    },
    gMakeid(length) {
      var result = '';
      var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      var charactersLength = characters.length;
      for (var i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() *
            charactersLength));
      }
      return result;
    },
    changeHeaderName(name){
       return this.headerName=name;
    },
   setTextToUpperCase(text){
     return  text.length > 0 && true ? text.toString().toUpperCase() : text;
   },
    limiText( text,length){
        return text && text.length > length && text.length > 0 && true ? text.substring(0, length) + "..." : text;
    },
    goToMarchandUrl(tr){
      let url=tr.action!==undefined ? tr.action.callback_url : tr.marchand._web_site!==undefined ? tr.marchand._web_site : 'intram.org';
      url= this.urlheecker(url);
      location.replace(url);
    },
    redirectByName(tr){
      router.push(tr).catch((e)=> {
        console.log('error',e);
      })
    },
    redirectByUrl(tr){
      location.replace(location.origin+''+tr);
    },
    urlheecker(href){
      return !href.includes('http') ? 'http://'+href : href;
    },
    toast(type,message){
      let vueBOx=this,
        Toast= this.$swal.mixin({
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 5000,
          timerProgressBar: true,
          didOpen: (toast) => {
            toast.addEventListener('mouseenter', vueBOx.$swal.stopTimer)
            toast.addEventListener('mouseleave', vueBOx.$swal.resumeTimer)
          }
        });
      Toast.fire({
        icon: type,
        title: message
      })
    },
   async confirm_toast(type,title,message,cancelbtnName,confirmbtnName,arg,arg2=()=>{console.log('confirm eror')}){
      this.$swal({
        title: title,
        text: message,
        icon: type,
        showCancelButton: true,
        confirmButtonColor: '#29b3a6',
        cancelButtonColor: '#801513',
        cancelButtonText: cancelbtnName,
        confirmButtonText: confirmbtnName,
      }).then(async (result) => {
        if (result.value) {
          await  arg();
        }else{
          await arg2()
        }
      })
    },
    copieToClipboard(text){
      let vbox=this;
      navigator.clipboard.writeText(text).then(() => {
        vbox.toast('success',"Texte copié avec succès!")
       })
    },
    logout(){
        let VueBox = this;
      this.$swal({
        title: 'Déconnexion',
        text: "Vous êtes sur le point de vous déconnecter ",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#29b3a6',
        cancelButtonColor: '#801513',
        cancelButtonText: 'Annuler',
        confirmButtonText: 'Déconnecter',
      }).then((result) => {
        if (result.value) {
          store.dispatch('auth/logout').then(()=>{
          VueBox.toast('warning','Redirection en cours...');
            location.reload();
          })
        }
      })
    },
    logoutUser(){
      let vueBox=this;
          store.dispatch('auth/logout').then(result=>{
          vueBox.toast('warning','Redirection en cours...');
            location.reload();
          });
    }
  }
})

Vue.config.productionTip = false;
/* eslint-disable no-new */

/*if (process.env.VUE_APP_ENV==="production"){
    if(!window.console) window.console = {};
    var methods = ["log", "debug", "warn", "info","error"];
    for(var i=0;i<methods.length;i++){
        console[methods[i]] = function(){};
    }

    if(typeof(console) === 'undefined') {
        console = {}
    }

    if( typeof(console.log) === 'undefined') {
        // FYI: Firebug might get cranky...
        console.log = console.error = console.info = console.debug = console.warn = console.trace = console.dir = console.dirxml = console.group = console.groupEnd = console.time =    console.timeEnd = console.assert = console.profile = function() {};
    }
}*/

new Vue({
  i18n,
  store,
  router,
  vuetify,
  CountryFlag,
  loader:loader,
  render: h => h(App)
}).$mount('#app');

